export enum MediasoupEndpointErrorCode {
    SUCCESS = 0,
    GENERIC_ERROR = 1,
    PRODUCER_ERROR = 2,
    CANNOT_CONSUME_ERROR = 3
}